<template>
  <div class="mvc-detail">
    <div class="base-info-box">
      <div class="title">基础信息</div>
      <el-row class="row">
        <el-col class="col-title" :span="colTitleSpan">商品名称：</el-col>
        <el-col class="col-value" :span="colValueSpan">{{ baseInfo.name }}</el-col>
      </el-row>
      <el-row class="row">
        <el-col class="col-title" :span="colTitleSpan">图片：</el-col>
        <el-col class="col-value" :span="colValueSpan">
          <el-image class="picture" :src="baseInfo.picture" fit="contain" alt="" />
        </el-col>
      </el-row>
      <el-row class="row">
        <el-col class="col-title" :span="colTitleSpan">数据来源：</el-col>
        <el-col class="col-value" :span="colValueSpan">{{ baseInfo.source == 'Runtu' ? '闰土自制' : '券中台投放' }}</el-col>
      </el-row>
      <el-row class="row">
        <el-col class="col-title" :span="colTitleSpan">储值卡：</el-col>
        <el-col class="col-value" :span="colValueSpan">
          <Table :tableThData="tableThData" :tableTrData="tableTrData" :pagination="false" >
            <template #id="{ row }">{{ row.id }}</template>
            <template #name="{ row }">{{ row.name }}</template>
            <template #useRangeType="{ row }">{{ row.useRangeType }}</template>
            <template #amount="{ row }">{{ row.amount }}</template>
            <template #giveType="{ row }">{{ row.giveType || '---'}}</template>
            <template #effectiveStr="{ row }">{{ row.effectiveStr || '---'}}</template>
          </Table>
        </el-col>
      </el-row>
      <el-row class="row">
        <el-col class="col-title" :span="colTitleSpan">是否同步渠道：</el-col>
        <el-col class="col-value" :span="colValueSpan">{{ baseInfo.syncChannel ? '是' : '否' }}</el-col>
      </el-row>
      <el-row class="row" v-if="baseInfo.syncChannel">
        <el-col class="col-title" :span="colTitleSpan">渠道序号：</el-col>
        <el-col class="col-value" :span="colValueSpan">{{ baseInfo.sortNum }}</el-col>
      </el-row>
      <el-row class="row">
        <el-col class="col-title" :span="colTitleSpan">上架渠道：</el-col>
        <el-col class="col-value" :span="colValueSpan">{{ baseInfo.platformName }}</el-col>
      </el-row>
      <el-row v-if="baseInfo.platform == 'AlipayMiniapp'" class="row">
        <el-col class="col-title" :span="colTitleSpan">支付宝活动ID：</el-col>
        <el-col class="col-value" :span="colValueSpan">{{ baseInfo.outAssociationId }}</el-col>
      </el-row>
      <el-row v-if="baseInfo.platform == 'AlipayMiniapp'" class="row link-row">
        <el-col class="col-title" :span="colTitleSpan">活动链接：</el-col>
        <el-col class="col-value" :span="colValueSpan">
          <div class="link-box">{{ baseInfo.outAssociationUrl }}</div>
        </el-col>
      </el-row>
      <el-row class="row">
        <el-col class="col-title" :span="colTitleSpan">上架数量：</el-col>
        <el-col class="col-value" :span="colValueSpan">{{ baseInfo.quantity }}</el-col>
      </el-row>
      <el-row class="row">
        <el-col class="col-title" :span="colTitleSpan">剩余数量：</el-col>
        <el-col class="col-value" :span="colValueSpan">{{ baseInfo.remainingQuantity }}</el-col>
      </el-row>
      <el-row class="row">
        <el-col class="col-title" :span="colTitleSpan">每人限购次数：</el-col>
        <el-col class="col-value" :span="colValueSpan">{{ baseInfo.userTotalLimit ? '每人总限购' + baseInfo.userTotalLimit + '次' : (baseInfo.intervalLimitDays ? '每' + baseInfo.intervalLimitDays + '天内限购' + baseInfo.userIntervalLimit + '次' : '无限制') }}</el-col>
      </el-row>
      <el-row class="row">
        <el-col class="col-title" :span="colTitleSpan">售卖时间：</el-col>
        <el-col class="col-value" :span="colValueSpan">{{ baseInfo.salesStartTime + '-' + baseInfo.salesEndTime }}</el-col>
      </el-row>
      <el-row class="row">
        <el-col class="col-title" :span="colTitleSpan">售价：</el-col>
        <el-col class="col-value" :span="colValueSpan">{{ baseInfo.actualAmount }}元</el-col>
      </el-row>
      <el-row class="row">
        <el-col class="col-title" :span="colTitleSpan">优惠：</el-col>
        <el-col class="col-value" :span="colValueSpan">{{ baseInfo.discount }}元</el-col>
      </el-row>
      <auth-button auth="storedCard:mall:share:commission" :displayType="'block'">
        <el-row class="row">
          <el-col class="col-title" :span="colTitleSpan">店铺分销佣金：</el-col>
          <el-col class="col-value" :span="colValueSpan">{{ baseInfo.storeCommission? `${baseInfo.storeCommission}元`: '未配置' }}</el-col>
        </el-row>
        <el-row class="row">
          <el-col class="col-title" :span="colTitleSpan">用户分销佣金：</el-col>
          <el-col class="col-value" :span="colValueSpan">{{ baseInfo.commission?`${baseInfo.commission}元`: '未配置' }}</el-col>
        </el-row>
        <el-row class="row">
          <el-col class="col-title" :span="colTitleSpan">二级分销佣金：</el-col>
          <el-col class="col-value" :span="colValueSpan">{{ baseInfo.secondaryCommission?`${baseInfo.secondaryCommission}元`: '未配置' }}</el-col>
        </el-row>
        <el-row class="row">
          <el-col class="col-title" :span="colTitleSpan">邀请人佣金：</el-col>
          <el-col class="col-value" :span="colValueSpan">{{ baseInfo.inviterCommission?`${baseInfo.inviterCommission}元`: '未配置' }}</el-col>
        </el-row>
      </auth-button>
    </div>
    <div class="footer">
      <el-button @click="onBack">返回</el-button>
    </div>
  </div>
</template>

<script>
import UploadImg from '@/components/UploadImg/index'
import { api_getValueCardStoreDetail } from '@/api/valueCardStore'
import Table from "@/components/Table/index";
import AuthButton from '@/components/AuthButton'
export default {
  name: "mvcDetail",
  components: {
    UploadImg,
    Table,
    AuthButton
  },
  data() {
    return {
      baseInfo: {}, // 基础信息数据
      colTitleSpan: 3,
      colValueSpan: 21,
      tableThData: [
        { prop: "id", label: "储值卡ID", minWidth: "80", },
        { prop: "name", label: "储值卡名称", minWidth: "120", },
        { prop: "useRangeType", label: "使用范围", minWidth: "120", },
        { prop: "amount", label: "面值", minWidth: "100", },
        { prop: "giveType", label: "赠礼类型", minWidth: "100", },
        { prop: "effectiveStr", label: "卡有效时间", minWidth: "180",},
      ],
      tableTrData: [],
      effectiveMap: {
        '0': '下架',
        '1': '上架',
      },
      form: {},
    };
  },
  created() {},
  mounted() {
    this.getDetailData() // 获取详情数据
  },
  methods: {
    returnFloat(key, num) {
      num = num || 0.00
      num = num.toString(); // 转成字符串类型  如能确定类型 这步可省去
      if (num.indexOf(".") !== -1) {
        let [integerPart, decimalPart] = num.split(".");
        if (decimalPart.length > 2) {
          decimalPart = decimalPart.substring(0, 2);
        } else if (decimalPart.length === 1) {
          decimalPart += "0";
        }
        num = `${integerPart}.${decimalPart}`;
      } else {
        num += ".00";
      }
      this.baseInfo[key] = num;
    },
    // 获取详情数据
    async getDetailData() {
      const res = await api_getValueCardStoreDetail({skuId: this.$route.query.skuId})
      this.baseInfo = res
      this.tableTrData = [res.storedCardTemplateVO]
      this.returnFloat('storeCommission', this.baseInfo.storeCommission)
      this.returnFloat('commission', this.baseInfo.commission)
    },

    // 返回
    onBack() {
      this.$router.back(-1)
    },
  },
  watch: {},
  computed: {},
};
</script>
<style lang="scss" scoped>
.mvc-detail {
  width: 100%;
  padding: 35px 20px;
  box-sizing: border-box;
  position: relative;
  padding-bottom: 100px;

  .picture {
    width: 150px;
    height: 150px;
    border: 1px solid #ccc;
  }

  .img-cover {
    width: 250px;
    height: 150px;
    border: 1px solid #ccc;
  }
  .row-info {
    min-height: 34px;
    line-height: 34px;
    margin-bottom: 20px;
    font-size: 14px;

    .col-label {
      text-align: right;
      padding-right: 20px;
      color: #666;
    }

    .col-value {
      color: #000;
    }
  }
  .remark-box {
    width: 100%;
    min-height: 300px;
    max-height: 500px;
    overflow: auto;

    &::v-deep img {
      width: 100% !important;
    }
  }

  .row {
    min-height: 50px;
    line-height: 50px;
    font-size: 14px;
    color: #666666;

    .col-title {
      text-align: right;
    }

    .col-value {
      min-height: 50px;
      color: #333333;

      .rule-box {
        background-color: #F2F3F5;
        padding: 20px;
        color: #999;
        font-size: 14px;
        max-width: 400px;
        border-radius: 2px;
      }
    }
  }

  .link-row {
    display: flex;
    align-items: center;
  }
  .link-box {
    width: 400px;
    word-wrap: break-word;
    word-break: break-all;
    overflow: hidden;
    line-height: 20px;
  }

  .title {
    margin: 0;
    margin-bottom: 30px;
    padding-left: 15px;
    height: 25px;
    line-height: 25px;
    font-size: 18px;
    font-weight: 500;
    color: #333333;
    position: relative;

    .title-remark {
      color: #666666;
      font-size: 14px;
    }

    &::before {
      position: absolute;
      top: 0;
      left: 0;
      content: '';
      width: 5px;
      height: 25px;
      border-radius: 2px;
      background: #05C8AF;
    }
  }

  .footer{
    position: fixed;
    bottom: 0;
    padding: 20px 0;
    padding-left: 70px;
    background: #fff;
    width: calc(100vw - #{$base-left-menu-width});
    left: $base-left-menu-width;
  }
}
</style>
